export default "__VITE_PUBLIC_ASSET__8024a749__"